import { DELETE_IMAGE, UPLOAD_IMAGE } from "../../Teams/TeamsService";
import { FILE_TYPES } from "../../../utility/Enum";

const getLogoFileName = (url) => {
  const name = url.split(/[?#]/)[0].split("/").pop();
  try {
    return decodeURIComponent(name);
  } catch {
    return name;
  }
};

// Keep checkpoints for this drawer session independently of other form writes.
export const createClubLogoSaver = (initialLogo) => {
  let currentLogo = {
    selection: initialLogo || null,
    fileName: initialLogo ? getLogoFileName(initialLogo) : null,
    uploadComplete: true,
  };

  return async ({ logo, clubId, graphql, put = fetch }) => {
    const selection = logo || null;
    if (selection === currentLogo.selection && currentLogo.uploadComplete) return;

    if (currentLogo.fileName && selection !== currentLogo.selection) {
      await graphql({
        query: DELETE_IMAGE,
        variables: {
          deleteType: FILE_TYPES.clubLogo,
          itemId: clubId,
          fileName: currentLogo.fileName,
        },
      });
      currentLogo = { selection: null, fileName: null, uploadComplete: true };
    }

    if (!selection?.name) return;

    // An incomplete PUT needs a fresh ticket, but must not repeat an old delete.
    const response = await graphql({
      query: UPLOAD_IMAGE,
      variables: {
        uploadType: FILE_TYPES.clubLogo,
        itemId: clubId,
        fileName: selection.name,
        size: selection.size,
      },
    });
    const uploadUrl = response.data.data.uploadImage;
    // The API may rename collisions and changes logo metadata when issuing the
    // ticket. Track that actual filename even if the subsequent PUT fails.
    currentLogo = {
      selection,
      fileName: getLogoFileName(uploadUrl),
      uploadComplete: false,
    };
    const uploadResponse = await put(uploadUrl, { method: "PUT", body: selection });
    if (!uploadResponse.ok) throw new Error("error_uploading_image");
    currentLogo.uploadComplete = true;
  };
};
